import * as React from "react";
const SvgAsc = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 10, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "M14.17 7.92 10 3.75 5.83 7.92zm0 4.16L10 16.25l-4.17-4.17z" }));
export default SvgAsc;
